import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import routes from './routes'
import axios from 'axios'
import VueAxios from 'vue-axios'
import env from '../env'
import Vant from 'vant'
import 'vant/lib/index.css'
import './components/index'

import auth from '@websanova/vue-auth/src/v2.js'
import driverAuthBearer from '@websanova/vue-auth/src/drivers/auth/bearer.js'
import driverHttpAxios from '@websanova/vue-auth/src/drivers/http/axios.1.x.js'
import driverRouterVueRouter from '@websanova/vue-auth/src/drivers/router/vue-router.2.x.js'
import 'v2-datepicker/lib/index.css';   // v2 need to improt css
import V2Datepicker from 'v2-datepicker';
import VueCryptojs from 'vue-cryptojs'
import './app.scss'
import Vue2Editor from 'vue2-editor'

Vue.use(Vue2Editor)
Vue.use(VueAxios, axios)
Vue.use(VueRouter)
Vue.use(Vant)
Vue.use(V2Datepicker)
Vue.use(VueCryptojs)
const router = new VueRouter({
  mode: 'history',
  routes,
  linkExactActiveClass: 'active',
})

// Vue.use(auth, {
//   plugins: {
//     http: Vue.axios,
//     router,
//   },
//   drivers: {
//     auth: driverAuthBearer,
//     http: driverHttpAxios,
//     router: driverRouterVueRouter,
//   },
//   options: {
//     staySignedIn: true,
//     stores: ['storage'],
//     loginData: {
//       url: 'admin/auth/login',
//       method: 'POST',
//     },
//     registerData: {
//       url: 'admin/auth/login',
//       method: 'POST',
//     },
//     fetchData: {
//       url: 'user',
//       method: 'GET',
//     },
//     refreshData: {
//       url: 'refresh',
//       method: 'GET',
//     },
//   },
// })

window.axios = axios
window.userTZ = Intl.DateTimeFormat().resolvedOptions().timeZone
axios.defaults.baseURL = env.baseUrl
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.common['X-TZ'] = window.userTZ

let vueApp = new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app')

// listen for axios interceptors to show error
axios.interceptors.response.use((res) => {
  vueApp.$toast.clear()

  if (res.data.success) {
    return res
  }
  // validation error
  if (res.data.code == 422) {
    return res
  }

  vueApp.$dialog.alert({
    title: 'Error',
    message: res.data.error,
    showCancelButton: false,
    confirmButtonText: 'OK',
  })

  return res
})
